module.exports = __webpack_public_path__ + "static/media/Results-1.ad3a6faf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proof/Results-1.jpg
// module id = 362
// module chunks = 0